<div class="share-widget-access-security">
  <h5 class="mb-0">Security</h5>

  <!-- Field lines use the design system's own: a field's description input, the text input's error
       input, and for controls without one its description (.sb-field__description) or error element
       (.sb-field__error .invalid-text). What the chosen sign option means sits under the options,
       as its own line. -->
  <div class="share-widget-access-security__setting">
    <app-sb-input-radio
      layout="horizontal"
      ariaLabel="Sign option"
      [options]="signModeOptions"
      [ngModel]="signMode"
      (ngModelChange)="onSignModeChange($event)"
      [disabled]="controlsDisabled"
    ></app-sb-input-radio>
    <div *ngIf="signModeInfo" class="sb-field__description">{{signModeInfo}}</div>
    <div *ngIf="signModeWarning" class="bar error-brd sb-field__error">
      <div class="invalid-text">{{signModeWarning}}</div>
    </div>
  </div>

  <div class="share-widget-access-security__setting" *ngIf="tokenVisible">
    <div class="share-widget-access-security__token-row">
      <app-sb-input-text
        class="share-widget-access-security__token-input"
        [label]="tokenLabel"
        [help]="tokenHelp"
        [description]="tokenDescription"
        [error]="tokenError"
        [ngModel]="tokenInput"
        (ngModelChange)="onTokenInputChange($event)"
        [disabled]="controlsDisabled"
      ></app-sb-input-text>
      <app-sb-button
        variant="outline-secondary"
        icon="fa fa-refresh"
        label="Generate"
        [disabled]="controlsDisabled"
        (clicked)="generateToken()"
      ></app-sb-button>
    </div>
  </div>

  <div class="share-widget-access-security__setting" *ngIf="signMode === 'global_token'">
    <app-sb-input-checkbox
      label="Allow influencer edit via global token"
      [ngModel]="globalTokenEdit"
      (ngModelChange)="globalTokenEdit = $event"
      [disabled]="controlsDisabled"
    ></app-sb-input-checkbox>
    <div *ngIf="globalTokenEdit" class="bar error-brd sb-field__error">
      <div class="invalid-text">{{globalTokenEditWarning}}</div>
    </div>
  </div>

  <div class="share-widget-access-security__setting" *ngIf="signMode === 'request_sign'">
    <app-sb-input-checkbox
      label="Include expiry (+30 days)"
      description="Applies to the sample links and code on this page. It is not saved."
      [ngModel]="includeExpiry"
      (ngModelChange)="onIncludeExpiryChange($event)"
      [disabled]="controlsDisabled"
    ></app-sb-input-checkbox>
    <div *ngIf="!includeExpiry" class="bar error-brd sb-field__error">
      <div class="invalid-text">Without an expiry the link works until the salt changes.</div>
    </div>
  </div>
  <!-- Save is the tab's sticky action row, at the end of the tab, so it stays in view. -->
</div>
